import React, { Fragment } from 'react';
import { Card } from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import {
  PolarAreaChart
} from '../../charts';
import { ThemeColors } from '../../../../../../helpers/ThemeColors';
const colors = ThemeColors();
const EmailStatsPiChart = ({ labels, data, title, subtitle }) => {
  const datasets = data.map((elem) => elem.count);
  const pieChartData = {
    labels,
    datasets: [
      {
        label: 'clicks',
        data: datasets,
        // borderColor: colors.themeColor1,
        pointBackgroundColor: colors.foregroundColor,
        pointBorderColor: colors.themeColor1,
        pointHoverBackgroundColor: colors.themeColor1,
        pointHoverBorderColor: colors.foregroundColor,
        pointRadius: 4,
        pointBorderWidth: 2,
        pointHoverRadius: 5,
        fill: false,
        borderWidth: 2,
        // backgroundColor: ['#ef4a81', 'green', 'red'],
        backgroundColor: [
          'rgba(244, 67, 54, 0.2)',
          'rgba(255, 193, 7, 0.2)',
          'rgba(76, 175, 80, 0.2)',
        ],
        borderColor: [
          '#f44336',
          '#ffc107',
          '#4caf50',
        ],
      },
    ],
  };
  return (
    <Fragment>
      <Card className={`dashboard-filled-line-chart`}>
        <div style={{ padding: '15px' }}>
          <div className="float-left float-none-xs">
            <div className="d-inline-block">
              <h5 className="d-inline">
                <IntlMessages id={title} />
              </h5>
              <span className="text-muted text-small d-block">
                {/* <IntlMessages id={subtitle} /> */}
              </span>
            </div>
          </div>
        </div>

        <div className="chart card-body pt-0">
          <PolarAreaChart data={pieChartData} />
        </div>
      </Card>
    </Fragment>
  );
};

export default EmailStatsPiChart;
